module.exports = __webpack_public_path__ + "static/media/power_inverter.86c982d8.jpg";